export default __webpack_public_path__ + "static/media/line-v-17.0b6843c2.png";